module.exports = __webpack_public_path__ + "static/media/case-della-costituzione.aa610a6c.svg";